import React from 'react'
import { useSelector, useDispatch } from 'react-redux'

import {
  CCloseButton,
  CSidebar,
  CSidebarBrand,
  CSidebarFooter,
  CSidebarHeader,
  // CSidebarToggler,
} from '@coreui/react'
import { AppSidebarNav } from './AppSidebarNav'
import { logoutRequestAction } from '../store/account/userActions'
import CIcon from '@coreui/icons-react'
import { cilExitToApp, cilArrowCircleLeft } from '@coreui/icons'

const AppSidebar = () => {
  const dispatch = useDispatch()
  const unfoldable = useSelector((state) => state.sidebar.sidebarUnfoldable)
  const sidebarShow = useSelector((state) => state.sidebar.sidebarShow)

  const _toggleSidebar = () => {
    dispatch({ 
      type: 'set', 
      sidebarShow: !sidebarShow 
    })
  }

  const toggleUnfoldable = () => {
    dispatch({ 
      type: 'set', 
      sidebarUnfoldable: !unfoldable 
    })
  }

  return (
    <CSidebar
      className="border-end"
      colorScheme="dark"
      position="fixed"
      unfoldable={unfoldable}
      visible={sidebarShow}
      onVisibleChange={(visible) => {
        if (window.innerWidth >= 768) {
          dispatch({ type: 'set', sidebarShow: visible })
        }
      }}
    >
      <CSidebarHeader className="border-bottom">
        <CSidebarBrand className="d-flex justify-content-between align-items-center" to="/">
          <div className="d-flex align-items-center">
          <span className="sidebar-brand-full" onClick={() => window.location.href = '/home'}>
            Fabco
          </span>
          </div>
          <div className="d-flex">
            <div 
              className="sidebar-toggler-wrapper"
              onClick={toggleUnfoldable}
            >
              <CIcon 
                icon={cilArrowCircleLeft} 
                className={`sidebar-toggler-icon ${unfoldable ? 'rotated' : ''}`}
              />
            </div>
            <CCloseButton
              className="d-lg-none ms-2"
              dark
              onClick={() => dispatch({ type: 'set', sidebarShow: false })}
            />
          </div>
        </CSidebarBrand>
      </CSidebarHeader>

      <AppSidebarNav />

      <CSidebarFooter className="border-top d-none d-lg-flex">
        <div 
          className="d-flex align-items-center justify-content-center p-3"
          style={{ cursor: 'pointer' }}
          onClick={() => dispatch(logoutRequestAction())}
        >
          <CIcon 
            icon={cilExitToApp} 
            size="lg"
            className="text-danger"
          />
        </div>
      </CSidebarFooter>
    </CSidebar>
  )
}

export default React.memo(AppSidebar)
